import { format } from "date-fns";

const formatMessageDate = (date) => {
  const messageDate = new Date(date);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (messageDate.toDateString() === today.toDateString()) {
    return "Today";
  } else if (messageDate.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  } else {
    return format(messageDate, "MMMM do, yyyy");
  }
};
const groupMessagesByDate = (messages) => {
  if (!messages?.length) return [];

  const groupedMessages = [];
  let currentGroupDate = null;

  messages?.forEach((message) => {
    const messageDateGroup = formatMessageDate(message.createdAt);

    if (messageDateGroup !== currentGroupDate) {
      currentGroupDate = messageDateGroup;
      groupedMessages.push({ dateGroup: currentGroupDate, messages: [] });
    }

    const group = groupedMessages[groupedMessages.length - 1];
    group.messages.push(message);
  });

  return groupedMessages;
};

export { groupMessagesByDate };
